import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { BlogService } from '../services/blog.service';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SlugGuard  {

  constructor(
    protected router: Router,
    protected blogService: BlogService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const slug = `${state.url}`;
    if (environment.debug) {
      console.dir('SLUG: ' + slug);
    }
    const noQueryParams = slug.split('?')[0];
    const segments = noQueryParams.split('/');
    const categorySlug = segments[1];
    const articleSlug = segments[2];
    return this.blogService.checkSlug()
      .pipe(
        take(1),
        map(([cat, art]) => {
          let categoryExists = false;
          let articleExists = false;
          if (cat && !cat.error) {
            categoryExists = cat.findIndex((el: any) => el.slug === categorySlug) !== -1;
          }
          if (art && !art.error) {
            if (!!articleSlug) {
              this.blogService.currentArticleSlug = articleSlug;
              articleExists = art.articles.includes(articleSlug);
            }
          }

          const valid = !!articleSlug ? categoryExists && articleExists : categoryExists;
          if (valid) {
            // slugs are valid
            return true;
          } else {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/404']);
            return false;
          }
        })
      );
  }
}
